import { render, staticRenderFns } from "./MsTeams.vue?vue&type=template&id=ba5df282&"
import script from "./MsTeams.vue?vue&type=script&lang=js&"
export * from "./MsTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports